import React, { Suspense } from "react";
import { BROKERS, EXCHANGES } from "src/context/constants";
import { useExchange } from "src/hooks";


interface RegisterPopUpInterface {
	open: boolean;
	handleClose: any;
	handleSwitch: any;
}

const RegisterPopUp: React.FC<RegisterPopUpInterface> = ({
	open,
	handleClose,
	handleSwitch,
}) => {
	// const broker = useBroker()
	const exchange = useExchange()

	const regiserPopupManager = () => {
    switch(exchange) {
      case EXCHANGES.settrade : return React.lazy(() => import('./settrade'));
      case EXCHANGES.bitkub : return React.lazy(() => import('./bitkub'));
      default : return React.lazy(() => import('./settrade')); 
    }
  }

	const RegisterMultiBrokerPopup = regiserPopupManager()

	return (
		<React.Fragment>
			<Suspense fallback={<div></div>}>
				<RegisterMultiBrokerPopup
					open={open}
					handleClose={handleClose}
					handleSwitch={handleSwitch}
				/>
			</Suspense>
		</React.Fragment>
	)
};

export default RegisterPopUp;
